import axiosInstance from "../../../services/axiosInstance";
import axiosInstanceMultipart from "../../../services/axiosInstanceMultipart";


export const getUserInfo = async (request = {}) => {
    const response = await axiosInstance.get('users/profiles/info',  request );
    return response.data;
};

export const getContent = async (slug) => {
    const response = await axiosInstance.get(`contents/${slug}` );
    return response.data;
};

export const getWalletDetail = async (params = null) => {
    const response = await axiosInstance.get(`wallets/transactions`,{params} );
    return response.data;
};

export const getReagents = async (params = null) => {
    const response = await axiosInstance.get(`users/reagents`,{params} );
    return response.data;
};

export const updateProfile = async (request = null) => {
    const response = await axiosInstanceMultipart.post('users/update-profile',request  );
    return response.data;
};

export const getOrganizationInfo = async (params = null) => {
    const response = await axiosInstance.get('organization', {params}  );
    return response.data;
};
